import React from 'react'

import { GamesCategoriesPolling } from './GamesCategoriesPolling'
import NewGamesPolling from './NewGamesPolling'
import TopSlotsPolling from './TopSlotsPolling'

const ExternalGamesPolling: React.FC = () => (
  <>
    <GamesCategoriesPolling />
    <NewGamesPolling />
    <TopSlotsPolling />
  </>
)

export default ExternalGamesPolling
